import { GraphQLObjectType, GraphQLNonNull, GraphQLInt } from 'graphql'
import {
  VulnerabilityStatusBreakdown,
  vulnerabilityStatusBreakdown
} from './vulnerability-status-breakdown'
import { CRITICAL, HIGH, MEDIUM, LOW, NOTE } from '../shared'

export interface VulnerabilitySeverityBreakdown {
  readonly [CRITICAL]: VulnerabilityStatusBreakdown
  readonly [HIGH]: VulnerabilityStatusBreakdown
  readonly [MEDIUM]: VulnerabilityStatusBreakdown
  readonly [LOW]: VulnerabilityStatusBreakdown
  readonly [NOTE]: VulnerabilityStatusBreakdown
  readonly total: number
  readonly open: number
}

export const vulnerabilitySeverityBreakdown = new GraphQLObjectType({
  name: 'VulnerabilitySeverityBreakdown',
  description: 'Breakdown of a set of traces by severity',
  fields: () => ({
    [CRITICAL]: {
      type: new GraphQLNonNull(vulnerabilityStatusBreakdown)
    },
    [HIGH]: {
      type: new GraphQLNonNull(vulnerabilityStatusBreakdown)
    },
    [MEDIUM]: {
      type: new GraphQLNonNull(vulnerabilityStatusBreakdown)
    },
    [LOW]: {
      type: new GraphQLNonNull(vulnerabilityStatusBreakdown)
    },
    [NOTE]: {
      type: new GraphQLNonNull(vulnerabilityStatusBreakdown)
    },
    total: {
      type: new GraphQLNonNull(GraphQLInt)
    },
    open: {
      description: 'The total number of vulnerabilities with an open status',
      type: new GraphQLNonNull(GraphQLInt)
    }
  })
})
